import React from "react";
import TitleUnderlined from "../components/TitleUnderlined";
import { useParams } from "react-router-dom";
import Utils from "../tools/Utils";

const ThanksGroupView = () => {
    const { obj } = useParams();

    let totalBoletos = null;
    try {
        const decoded = Utils.decodeBase64(obj);
        const n = parseInt(decoded, 10);
        if (Number.isFinite(n) && n >= 0) {
            totalBoletos = n;
        }
    } catch {
        totalBoletos = null;
    }

    const boletosLabel =
        totalBoletos === null
            ? null
            : totalBoletos === 1
                ? '1 boleto'
                : `${totalBoletos} boletos`;

    return (
        <div className="pt-5 pb-5" id="paymentView">
            <br></br>
            <br></br>
            <TitleUnderlined><span className="embercom_overlined">Gracias</span> por registrar a tu grupo</TitleUnderlined>
            <br></br>
            <br></br>
            <br></br>
            <p>
                Gracias por registrar a tu grupo. Recuerda que el donativo total equivalente a la cantidad de personas que registraste, se entrega el mismo día del evento (29 de agosto de 2026), al momento de tu llegada.{' '}
                {boletosLabel !== null ? (
                    <>Hasta este momento tienes un total de {boletosLabel}.</>
                ) : (
                    <>Hasta este momento tu total acumulado de boletos no pudo mostrarse; revisa el historial en el registro de grupo si lo necesitas.</>
                )}{' '}
                Acuérdate que puedes sumar a más personas a tu grupo.
            </p>
            <p> El equipo del Encuentro Juvenil Católico (EJC), a través del “RP” asignado a ti, te hará llegar un documento con un código QR, es decir, un boleto digital que contiene el registro de todos tus participantes. Este, será enviado unos días antes del EJC.</p>
            <p>En caso de cualquier duda o problema, estamos para servirte.</p>
            <br></br>
            <a className="btn btn-main" style={{padding: '1rem 1.5rem'}} href={process.env.REACT_APP_BACK_URL}>Ir al sitio <img src={require('../assets/home.png')} alt="downloadIcon" style={{marginLeft: '10px',width: '25px',height:'25px',maxHeight:'25px'}} /></a>
        </div>
    )
}

export default ThanksGroupView;